import { gql } from '@/__generated__';

export const TournamentBannerFragment = gql(`
fragment TournamentBannerFragment on Tournament {
  id
  name
  image {
    key
  }
  medals {
    ...MedalCardFragment
  }
  headline
  category
  managedBy {
    id
    username
  }
  ...TournamentStatusFragment
}
`);
